module.exports = __webpack_public_path__ + "img/header-background.995b2526.jpg";